<template>
  <div class="growth-site">
    <HeroSection />
    <section
      id="grow"
      class="growth-section growth-story"
    >
      <div class="growth-section-heading">
        <p class="growth-eyebrow">
          {{ $t('refresh.more-than-upload') }}
        </p>
        <h2>{{ $t('refresh.story-title') }}<br><span>{{ $t('refresh.story-accent') }}</span></h2>
        <p>{{ $t('refresh.story-description') }}</p>
      </div>
      <div class="growth-feature-grid tw:grid tw:gap-5">
        <article class="growth-feature growth-feature--release">
          <span class="growth-feature__number">01 / {{ $t('refresh.release') }}</span>
          <div
            class="growth-vinyl"
            aria-hidden="true"
          >
            <span>indiefy</span>
          </div>
          <h3>{{ $t('refresh.release-title') }}</h3><p>{{ $t('refresh.release-description') }}</p>
          <router-link
            to="/auth/signup"
            class="growth-text-link"
          >
            {{ $t('refresh.release-action') }}<GrowthIcon name="up" />
          </router-link>
        </article>
        <article class="growth-feature growth-feature--audience">
          <span class="growth-feature__number">02 / {{ $t('refresh.understand') }}</span>
          <div
            class="growth-signal"
            aria-hidden="true"
          >
            <span
              v-for="(height, index) in bars"
              :key="index"
              :style="{ height: height + '%' }"
            />
          </div>
          <h3>{{ $t('refresh.understand-title') }}</h3><p>{{ $t('refresh.understand-description') }}</p>
          <router-link
            to="/auth/signup"
            class="growth-text-link"
          >
            {{ $t('refresh.understand-action') }}<GrowthIcon name="up" />
          </router-link>
        </article>
        <article class="growth-feature growth-feature--grow">
          <span class="growth-feature__number">03 / {{ $t('refresh.grow') }}</span>
          <div
            class="growth-orbit"
            aria-hidden="true"
          >
            <GrowthIcon name="spark" /><span /><span />
          </div>
          <h3>{{ $t('refresh.grow-title') }}</h3><p>{{ $t('refresh.grow-description') }}</p>
          <a
            href="#pricing"
            class="growth-text-link"
          >{{ $t('refresh.grow-action') }}<GrowthIcon name="up" /></a>
        </article>
      </div>
    </section>
    <section class="growth-pro-story growth-section">
      <div>
        <span class="refresh-pro-tag">INDIEFY PRO</span><h2>{{ $t('refresh.pro-title') }}<br><span>{{ $t('refresh.pro-accent') }}</span></h2><p>{{ $t('refresh.pro-description') }}</p><a
          href="#pricing"
          class="growth-button growth-button--lime growth-button--large"
        >{{ $t('refresh.explore-pro') }}<GrowthIcon name="up" /></a>
      </div>
      <div class="growth-pro-benefits">
        <article
          v-for="(benefit, index) in ['promote', 'insights', 'momentum']"
          :key="benefit"
        >
          <span>0{{ index + 1 }}</span><div><h3>{{ $t('refresh.pro-' + benefit) }}</h3><p>{{ $t('refresh.pro-' + benefit + '-description') }}</p></div><GrowthIcon name="up" />
        </article>
      </div>
    </section>
    <PricingSection />
    <FaqSection />
    <section class="growth-last-call growth-section">
      <p class="growth-eyebrow">
        {{ $t('refresh.your-next-chapter') }}
      </p><h2>{{ $t('refresh.last-title') }}</h2><router-link
        to="/auth/signup"
        class="growth-button growth-button--lime growth-button--large"
      >
        {{ $t('refresh.start-free') }}<GrowthIcon name="up" />
      </router-link><span aria-hidden="true">✳</span>
    </section>
    <footer class="growth-footer">
      <strong>indiefy<span>®</span></strong><p>{{ $t('refresh.made-independent') }}</p><nav :aria-label="$t('refresh.footer')">
        <router-link to="/terms-and-conditions">
          {{ $t('refresh.terms') }}
        </router-link><router-link to="/privacy-policy">
          {{ $t('refresh.privacy') }}
        </router-link><router-link to="/blog">
          {{ $t('navigation.blog') }}
        </router-link>
      </nav>
    </footer>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import HeroSection from '@/components/landing/HeroSection.vue';
import PricingSection from '@/components/landing/PricingSection.vue';
import FaqSection from '@/components/landing/FaqSection.vue';
import logoDark from '@/assets/images/logo-dark.png';
import { usePageSeo } from '@/composables/usePageSeo';
import {
  SITE_URL,
  buildOrganizationSchema,
  buildWebSiteSchema,
} from '@/config/seo';

const { t } = useI18n();

const logoAbsoluteUrl = computed(() => {
  if (typeof window === 'undefined') {
    return `${SITE_URL}${logoDark}`;
  }
  return new URL(logoDark, window.location.origin).href;
});

usePageSeo({
  titleKey: 'landing.page_title',
  descriptionKey: 'landing.page_description',
  keywords: computed(() => t('landing.meta_keywords')),
  jsonLd: computed(() => [
    buildOrganizationSchema(t, { logo: logoAbsoluteUrl.value }),
    buildWebSiteSchema(t),
  ]),
});


import GrowthIcon from '@/components/growth/GrowthIcon.vue';
const bars = [15, 27, 20, 42, 33, 50, 46, 66, 55, 81, 74, 100];
</script>
